import { render, staticRenderFns } from "./EncountersList.vue?vue&type=template&id=2ae53da3&"
import script from "./EncountersList.vue?vue&type=script&lang=js&"
export * from "./EncountersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports